import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store';
import { useSaveForm } from '@/shared/lib/useSaveForm';
import { createUser, saveUserPartnerGroup } from './api';
import { ProfileFields } from './ProfileFields';
import { FormErrorSummary, type ProfileFormApi } from './ProfileInputs';
import {
  buildCreateBody,
  emptyProfileValues,
  getProfilePermissions,
  hasAutoparkRole,
  type ProfileValues,
} from './profileForm';

const createProfile = async (values: ProfileValues) => {
  const res = await createUser(buildCreateBody(values));
  if (res.user_id && values.partnerGroupId && hasAutoparkRole(values.roles)) {
    try {
      await saveUserPartnerGroup(values.partnerGroupId, res.user_id);
    } catch {
      // The profile already exists; the partner can still be set on its edit page.
    }
  }
  return res;
};

export const UserCreatePage = () => {
  const navigate = useNavigate();
  const adminRoles = useAuthStore((s) => s.profile.roles);
  const [values, setValues] = useState(emptyProfileValues);

  const { errors, clearErrors, save, isPending } = useSaveForm(createProfile, (res) =>
    navigate(`/users/edit/${res.user_id}`),
  );

  const form: ProfileFormApi = {
    values,
    errors,
    patch: (change, ...touched) => {
      setValues((prev) => ({ ...prev, ...change }));
      clearErrors(...touched);
    },
  };

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    save(values);
  };

  return (
    <>
      <section className="content-header">
        <h1>Создание профиля</h1>
      </section>
      <section className="content">
        <div className="box box-primary">
          <div className="box-body">
            <form onSubmit={onSubmit}>
              <FormErrorSummary errors={errors} />
              <ProfileFields form={form} mode="create" permissions={getProfilePermissions(adminRoles)} />
              <button type="submit" className="btn btn-info" disabled={isPending}>
                Сохранить
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};
